import { z } from '@harvestiq/zod';
import { campaignSchema } from './campaign';

export const getCampaignByIdParamsSchema = z.object({
  campaignId: z.string().uuid(),
});
export type GetCampaignByIdParams = z.infer<typeof getCampaignByIdParamsSchema>;

export const getCampaignByIdResponseSchema = z.object({
  campaign: campaignSchema.nullable(),
});
export type GetCampaignByIdResponse = z.infer<
  typeof getCampaignByIdResponseSchema
>;
